import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=3105a65e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=3105a65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105a65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3105a65e')) {
      api.createRecord('3105a65e', component.options)
    } else {
      api.reload('3105a65e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=3105a65e&scoped=true&", function () {
      api.rerender('3105a65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21t6ySJ1Sh13S/JS/comp/GuestBox.vue"
export default component.exports